export const isPhoneRegisteredUpfront = false; // TBD: replace with feature flag or A/B testing

export const signupUrl = isPhoneRegisteredUpfront ? 'sign-in' : 'register';

export const liveEventSignupUrl = 'play-now';
